export const getDestinationFolderLabel = (destinationPrefix?: string): string => {
  const trimmedPrefix = destinationPrefix?.trim()

  return trimmedPrefix !== undefined && trimmedPrefix !== '' ? trimmedPrefix : 'the destination folder'
}
